import { DayView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  dayViewTimeScaleLayoutCustom: {
    '& > :first-of-type': {
      height: '100%',
      width: 50,
      '& > :first-of-type': {
        '& > :first-of-type': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          '& > :first-of-type': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
          },
        },
      },
    },
  },
});

export const DayViewTimeScaleLayoutCustom = (
  props: DayView.TimeScaleLayoutProps
) => {
  const { classes } = useStyles();
  return (
    <DayView.TimeScaleLayout
      {...props}
      className={classes.dayViewTimeScaleLayoutCustom}
    ></DayView.TimeScaleLayout>
  );
};
